import React from "react";
import "./ECLInput.css";
import { ECLNumber } from "../../../../index";

export default function ECLInterval(props) {
   return (
      <>
         <label>
            {props.name}{" "}
            {props.required && <span className="required-input">*</span>}
         </label>
         <div className="ecl-input-container-combo">
            <ECLNumber
               id={props.id}
               min={props.min}
               max={props.max}
               required={props.required}
               style={{ width: "calc(100% - 80px)" }} //hate inlining style, but needs to be based on length of selections below
            />
            <select
               className="ecl-input-selection"
               id={"select-" + props.id}
               style={{ width: "80px" }} //hate inlining style, but needs to be based on length of selections below>
            >
               <option value="Days">Days</option>
               <option value="Weeks">Weeks</option>
               <option value="Months">Months</option>
            </select>
         </div>
      </>
   );
}
